var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Select', _vm._g(_vm._b({
    attrs: {
      "closeOnSelect": false,
      "deselectFromDropdown": false,
      "get-option-key": function (option) {
        return option;
      },
      "get-option-label": function (option) {
        return option === null || option === void 0 ? void 0 : option.text;
      },
      "multiple": true,
      "reduce": function (option) {
        return option;
      },
      "value": _vm.dropdownValue
    },
    on: {
      "option:selected": _vm.onSelected
    }
  }, 'Select', _vm.$attrs, false), _vm.$listeners));

}
var staticRenderFns = []

export { render, staticRenderFns }